import React from 'react'
import {
  Box,
  Typography,
  Container,
  IconButton,
  useTheme,
  useMediaQuery,
  Divider,
} from '@mui/material'
import { Link } from 'react-router-dom'
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded'
import XIcon from '@mui/icons-material/X'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import InstagramIcon from '@mui/icons-material/Instagram'
import YouTubeIcon from '@mui/icons-material/YouTube'
import EmailRoundedIcon from '@mui/icons-material/EmailRounded'
const Footer = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const currentYear = new Date().getFullYear()
  const currentDomain =
    typeof window !== 'undefined' ? window.location.hostname : ''
  const isPrimaryDomain =
    currentDomain === 'gcctaxlaws.com' || currentDomain === 'www.gcctaxlaws.com'

  return (
    <Box
      component='footer'
      sx={{
        backgroundColor: '#232536',
        color: 'white',
        py: { xs: 3, md: 4 },
        position: 'relative',
      }}
    >
      <Container
        maxWidth='lg'
        sx={{
          position: 'relative',
          zIndex: 2,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: { xs: 'center', sm: 'space-between' },
            alignItems: 'center',
            mb: 3,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'center', sm: 'flex-start' },
              mb: { xs: 3, sm: 0 },
            }}
          >
            <Typography
              variant='h6'
              component='div'
              sx={{
                fontWeight: 700,
                mb: 1,
                fontSize: isPrimaryDomain
                  ? { xs: '1.25rem', md: '1.5rem' }
                  : { xs: '1.05rem', md: '1.25rem' },

                // backgroundImage: 'linear-gradient(45deg, #fff, #ffcf51)',
                // backgroundClip: 'text',
                // textFillColor: 'transparent',
                // WebkitBackgroundClip: 'text',
                // WebkitTextFillColor: 'transparent',

                color: '#ffcf51',
              }}
            >
              {isPrimaryDomain ? (
                'GCC Tax Laws'
              ) : (
                <>
                  Powered by{' '}
                  <Box
                    component='a'
                    href='https://gcctaxlaws.com'
                    target='_blank'
                    rel='noopener noreferrer'
                    sx={{
                      color: '#ffcf51',
                      textDecoration: 'underline',
                      textDecorationStyle: 'dotted',
                      textUnderlineOffset: '4px',
                      fontWeight: 700,
                      '&:hover': {
                        textDecorationStyle: 'solid',
                        textDecorationColor: '#ffcf51',
                      },
                    }}
                  >
                    GccTaxLaws
                  </Box>
                </>
              )}
            </Typography>
            <Typography
              variant='body2'
              sx={{
                color: '#c5c7cc',
                maxWidth: '300px',
                textAlign: { xs: 'center', sm: 'left' },
              }}
            >
              Your comprehensive resource for tax regulations in the GCC region.
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              gap: { xs: 0, md: 1 },
              justifyContent: 'center',
            }}
          >
            {[
              {
                icon: <XIcon />,
                label: 'Follow us on X',
                url: 'https://x.com/gcctaxlaws',
              },
              {
                icon: <LinkedInIcon />,
                label: 'Follow us on LinkedIn',
                url: 'https://www.linkedin.com/company/gcctaxlaws',
              },
              // { icon: <XIcon />, label: 'X', url: 'https://x.com/' },
              // {
              //   icon: <FacebookRoundedIcon />,
              //   label: 'Facebook',
              //   url: 'https://www.facebook.com/',
              // },
              {
                icon: <YouTubeIcon />,
                label: 'Subscribe to our channel',
                url: 'https://www.youtube.com/@gcctaxlaws',
              },
              {
                icon: <EmailRoundedIcon />,
                label: 'Email us',
                url: 'mailto:support@gcctaxlaws.com',
              },
            ].map((social, index) => (
              <IconButton
                key={index}
                aria-label={`${social.label}`}
                title={`${social.label}`}
                component={Link}
                to={social.url}
                sx={{
                  color: '#c5c7cc',
                  transition: 'all 0.3s ease',
                  transform: 'scale(1)',
                  '&:hover': {
                    color: '#ffcf51',
                    transform: 'scale(1.15)',
                  },
                }}
              >
                {social.icon}
              </IconButton>
            ))}
          </Box>
        </Box>

        <Divider sx={{ backgroundColor: 'rgba(255,255,255,0.1)', my: 2 }} />

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              display: 'grid',
              // Column 1: auto-width, Column 2: takes remaining space
              gridTemplateColumns: 'auto 1fr',
              // Two rows for the two lines of text on the right
              gridTemplateRows: 'auto auto',
              columnGap: 2, // Space between the copyright and the text
              alignItems: 'center', // Vertically centers items in their cells
              mb: { xs: 2, sm: 0 },
            }}
          >
            {/* Column 1: Spans both rows to stay centered vertically relative to the two lines */}
            <Typography
              variant='body2'
              sx={{
                color: '#c5c7cc',
                fontSize: { xs: '0.75rem', md: '0.875rem' },
                fontWeight: 500,
                gridRow: '1 / span 2', // Key: makes this span both rows
                whiteSpace: 'nowrap',
              }}
            >
              &copy; {currentYear}. All rights reserved.
            </Typography>

            {/* Column 2, Row 1 */}
            <Typography
              variant='body2'
              sx={{
                color: '#c5c7cc',
                fontSize: { xs: '0.75rem', md: '0.875rem' },
                lineHeight: 1.2,
              }}
            >
              Claritax Technology Solutions LLC FZ
            </Typography>

            {/* Column 2, Row 2 */}
            <Typography
              variant='body2'
              sx={{
                color: '#c5c7cc',
                fontSize: { xs: '0.75rem', md: '0.875rem' },
                lineHeight: 1.2,
                opacity: 0.8,
              }}
            >
              GCC Tax Laws
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              gap: 2,
            }}
          >
            {[
              'Privacy Policy',
              'Terms and Conditions',
              'Cookie Policy',
              'Enterprise Access',
            ].map((item, index) => (
              <Typography
                key={index}
                component={Link}
                to={`/${item.toLowerCase().replace(/\s+/g, '-')}`}
                variant='body2'
                sx={{
                  color: '#c5c7cc',
                  textDecoration: 'none',
                  fontSize: { xs: '0.75rem', md: '0.875rem' },
                  transition: 'color 0.3s ease',
                  '&:hover': {
                    color: '#ffcf51',
                  },
                }}
              >
                {item}
              </Typography>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
